import { useSelector } from "react-redux";
import { COLORS } from "utils/constants";

import medallionsImage from "assets/enhancements.svg";
import {
  TooltipDesc,
  TooltipInfo,
  TooltipName,
  TooltipValues,
  ValuesIcon,
} from "components/base/Tooltip";
import { getMedallions } from "redux/selectors/characterSelectors";

const TooltipMedallions = () => {
  const medallions = useSelector(getMedallions);

  return (
    <>
      <TooltipName>Medallions</TooltipName>
      <TooltipDesc>
        Medallions can be spent on increasing ship stats and training pilot
        skills in any city. Your total medallion amount is available to be used
        on both stats and skills independent of each other.
      </TooltipDesc>
      <TooltipDesc>
        You earn medallions when you defeat opponents. Higher battle ratings
        lead to more medallions.
      </TooltipDesc>
      <TooltipInfo>
        <TooltipValues color={COLORS.ENHANCEMENTS}>
          <ValuesIcon image={medallionsImage} color={COLORS.ENHANCEMENTS} />
          Medallions Earned: {medallions.total}
        </TooltipValues>
        <TooltipValues color={COLORS.ENHANCEMENTS}>
          <ValuesIcon image={medallionsImage} color={COLORS.ENHANCEMENTS} />
          Stat Medallions Spent: {medallions.statsSpent} / {medallions.total}
        </TooltipValues>
        <TooltipValues color={COLORS.ENHANCEMENTS}>
          <ValuesIcon image={medallionsImage} color={COLORS.ENHANCEMENTS} />
          Skill Medallions Spent: {medallions.skillsSpent} / {medallions.total}
        </TooltipValues>
        <TooltipValues color={COLORS.ENHANCEMENTS}>
          <ValuesIcon image={medallionsImage} color={COLORS.ENHANCEMENTS} />
          Medallions Available: {medallions.available} / {medallions.total}
        </TooltipValues>
      </TooltipInfo>
    </>
  );
};

export default TooltipMedallions;
